import { type Place } from "@xapp/components";

/**
 * Business types that are not supported for Book Online functionality.
 * We use a blacklist approach to specifically exclude these types.
 */
const UNSUPPORTED_BUSINESS_TYPES = [
    // Places of worship
    "church",
    "hindu_temple", 
    "mosque",
    "synagogue",
    "place_of_worship",
    
    // Educational institutions
    "library",
    "preschool", 
    "primary_school",
    "school",
    "secondary_school",
    "university"
];

/**
 * Determines if a business place has unsupported types for Book Online functionality.
 * 
 * @param place - The Google Business Profile place data
 * @returns true if the business type is not supported, false otherwise
 */
export function isUnsupportedBusinessType(place: Place): boolean {
    if (!place?.types || place.types.length === 0) {
        return false;
    }

    // Check if any of the place's types match our blacklist
    return place.types.some(type => UNSUPPORTED_BUSINESS_TYPES.includes(type));
}

/**
 * Gets a user-friendly description of why the business type is not supported.
 * 
 * @param place - The Google Business Profile place data
 * @returns A description of the unsupported business type, or null if supported
 */
export function getUnsupportedBusinessTypeReason(place: Place): string | null {
    if (!place?.types || place.types.length === 0) {
        return null;
    }

    const unsupportedTypes = place.types.filter(type => UNSUPPORTED_BUSINESS_TYPES.includes(type));
    
    if (unsupportedTypes.length === 0) {
        return null;
    }

    // Return a generic user-friendly message
    return "your business type";
}